import { h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import TitleCell from '../articles/cells/TitleCell'
import SimpleFilterSelector from '../overview/filters/SimpleFilterSelector'
import Overview from '../overview'
import PublishedInFilterSelector from '../overview/filters/PublishedInFilterSelector'
import RadioButtonFilterSelector from '../overview/filters/RadioButtonFilterSelector'
import DateFilterSelector from '../overview/filters/DateFilterSelector'
import UserFilterSelector from '../overview/filters/UserFilterSelector'
import LastActivityCell from "../overview/cells/LastActivityCell";

type Props = {
  categories: any[],
  contentTypes: any[],
  moderationLabels: any[],
  moderatorTags: any[],
  ideationStatuses: any[]
}

function normalizeCategories (categories: any[]) {
  return categories
    .filter(parent => parent.categories)
    .map(parent => {
      return {
        parentId: parent.groupId,
        parentName: parent.groupName,
        items: parent.categories.map((child: { categoryName: any; categoryId: any }, idx: any) => {
          return {
            id: idx,
            name: child.categoryName,
            value: child.categoryId
          }
        })
      }
    })
}

const ModerationOverview = ({ categories, contentTypes, moderationLabels, moderatorTags, ideationStatuses } : Props) => {
  function getDateSelectorItems () {
    return [
      {
        id: 1,
        type: 'relative',
        name: 'Less than',
        value: 'lt',
        unit: 'hour'
      },
      {
        id: 3,
        type: 'relative',
        name: 'More than',
        value: 'gt',
        unit: 'hour'
      },
      {
        id: 4,
        type: 'absolute',
        name: 'Before',
        value: 'before'
      },
      {
        id: 5,
        type: 'absolute',
        name: 'On',
        value: 'on'
      },
      {
        id: 6,
        type: 'absolute',
        name: 'After',
        value: 'after'
      }
    ]
  }
  function getFilters () {
    return [
      {
        id: 'category',
        name: 'Published in',
        type: 'simple',
        items: normalizeCategories(categories),
        component: PublishedInFilterSelector
      },
      {
        id: 'contentType',
        name: 'Content type',
        type: 'simple',
        items: contentTypes.map((contentType, idx) => ({ id: idx, name: `${contentType.charAt(0).toUpperCase()}${contentType.slice(1)}`, value: contentType })),
        component: SimpleFilterSelector
      },
      { id: 'separator', type: 'separator' },
      {
        id: 'assignedModerator',
        type: 'user',
        name: 'Assigned moderator',
        items: [],
        component: UserFilterSelector,
        fetchUrl: '/member/getModerators?query='
      },
      {
        id: 'moderationLabel',
        type: 'simple',
        name: 'Moderation label',
        items: moderationLabels.map((moderationLabel: any) => ({ id: moderationLabel.id, name: moderationLabel.title, value: moderationLabel.title })),
        component: SimpleFilterSelector,
        isSearchable: true
      },
      {
        id: 'moderatorTag',
        type: 'simple',
        name: 'Moderation tag',
        items: moderatorTags.map((moderatorTag: any) => ({ id: moderatorTag.id, name: moderatorTag.text, value: moderatorTag.text })),
        component: SimpleFilterSelector,
        isSearchable: true
      },
      { id: 'separator', type: 'separator' },
      {
        id: 'publishedAt',
        type: 'date',
        name: 'Publish date',
        items: getDateSelectorItems(),
        component: DateFilterSelector,
        isSearchable: true
      },
      {
        id: 'lastActivityAt',
        type: 'date',
        name: 'Last activity date',
        items: getDateSelectorItems(),
        component: DateFilterSelector
      },
      {
        id: 'ideationStatus',
        type: 'simple',
        name: 'Ideation status',
        items: ideationStatuses.map((ideationStatus: any) => ({ id: ideationStatus.id, name: ideationStatus.name, value: ideationStatus.name })),
        component: SimpleFilterSelector,
        isSearchable: true
      },
      { id: 'separator', type: 'separator' },
      {
        id: 'replies',
        type: 'radio',
        name: 'Replies',
        items: [
          {
            id: 1,
            name: 'More than',
            value: 'gt'
          },
          {
            id: 2,
            name: 'Equal to',
            value: 'eq'
          },
          {
            id: 3,
            name: 'Less than',
            value: 'lt'
          }
        ],
        component: RadioButtonFilterSelector
      }
    ]
  }
  function getColumns () {
    return [{
      header: 'Title', accessor: 'title', cell: TitleCell()
    }, {
      header: 'Category', accessor: 'categoryName'
    }, {
      header: 'Replies', accessor: 'replyCount'
    }, {
      header: 'Last Activity', accessor: 'lastActivity', cell: LastActivityCell(), sorting: 'lastActivityAt'
    }]
  }

  return <Overview
    type='moderation'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      lastActivityAt: 'desc'
    }}
    withFilters={getFilters()}
    withSearch
    counterLabel='Topics'
    rowId='id'
    model={getColumns()}
    endpoint='/overview/topics'
    dataKey='topics'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no topics yet'
      text={'Seems like no one on your team has created a topic. \n Start now by creating a new topic.'}
      button={{ link: '/content/new/article', text: 'New article' }}
    />}
  />
}

export default ModerationOverview
